<template>
  <base-page-layout
    class="ranking-produtos"
    title="Ranking de produtos"
    :filters="['data', 'clube', 'pessoa', 'lojas', 'segmentos']"
    default-date="ultimosTrintaDias"
  >
    <v-container fluid grid-list-md class="pa-0">
      <v-tabs v-model="activeTab" background-color="white" slider-color="primary" grow>
        <v-tab ripple @click="rankType = 'mais'">Maior participação</v-tab>
        <v-tab ripple @click="rankType = 'menos'">Menor participação</v-tab>
      </v-tabs>
      <v-divider />

      <v-card>
        <v-card-title>
          <div v-if="rankType === 'mais'">
            <span v-if="dataType === 'vendas'" class="pa-2 title">100 itens com maior quantidade vendida</span>
            <span v-if="dataType === 'faturamento'" class="pa-2 title">100 itens de maior faturamento</span>
            <span v-if="dataType === 'cupons'" class="pa-2 title">100 itens presentes em mais cupons</span>
            <span v-if="dataType === 'clientes'" class="pa-2 title">100 itens com mais clientes</span>
          </div>
          <div v-if="rankType === 'menos'">
            <span v-if="dataType === 'vendas'" class="pa-2 title">100 itens menos vendidos</span>
            <span v-if="dataType === 'faturamento'" class="pa-2 title">100 itens de menor faturamento</span>
            <span v-if="dataType === 'cupons'" class="pa-2 title">100 itens presentes em menos cupons</span>
            <span v-if="dataType === 'clientes'" class="pa-2 title">100 itens com menos clientes</span>
          </div>
          <v-spacer />
          <export-data :disabled="!selectedItems.length" class="mx-2" :data-fetcher="getDataToExport" filename="ranking_de_produtos" ghost />
          <mf-tabs-button v-model="dataType" size="sm" :buttons="toggleButtons" />
        </v-card-title>
        <div v-if="rankType === 'mais'">
          <top-mais-vendidos-card v-if="dataType === 'vendas'" @update-items="updateItems" />
          <top-maior-faturamento-card v-if="dataType === 'faturamento'" @update-items="updateItems" />
          <top-mais-cupons-card v-if="dataType === 'cupons'" @update-items="updateItems" />
          <top-mais-clientes-card v-if="dataType === 'clientes'" @update-items="updateItems" />
        </div>
        <div v-if="rankType === 'menos'">
          <top-menos-vendidos-card v-if="dataType === 'vendas'" @update-items="updateItems" />
          <top-menor-faturamento-card v-if="dataType === 'faturamento'" @update-items="updateItems" />
          <top-menos-cupons-card v-if="dataType === 'cupons'" @update-items="updateItems" />
          <top-menos-clientes-card v-if="dataType === 'clientes'" @update-items="updateItems" />
        </div>
      </v-card>
    </v-container>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ExportData from '@/components/export-data/ExportData.vue'
import TopMaisVendidosCard from '@/modules/produtos/ranking-produtos/views/pages/TopMaisVendidosCard.vue'
import TopMaisCuponsCard from '@/modules/produtos/ranking-produtos/views/pages/TopMaisCuponsCard.vue'
import TopMaisClientesCard from '@/modules/produtos/ranking-produtos/views/pages/TopMaisClientesCard.vue'
import TopMaiorFaturamentoCard from '@/modules/produtos/ranking-produtos/views/pages/TopMaiorFaturamentoCard.vue'
import TopMenosVendidosCard from '@/modules/produtos/ranking-produtos/views/pages/TopMenosVendidosCard.vue'
import TopMenosCuponsCard from '@/modules/produtos/ranking-produtos/views/pages/TopMenosCuponsCard.vue'
import TopMenosClientesCard from '@/modules/produtos/ranking-produtos/views/pages/TopMenosClientesCard.vue'
import TopMenorFaturamentoCard from '@/modules/produtos/ranking-produtos/views/pages/TopMenorFaturamentoCard.vue'
import { mapState } from 'vuex'

export default {
  name: 'RankingProdutos',
  components: {
    ExportData,
    BasePageLayout,
    TopMaisVendidosCard,
    TopMaiorFaturamentoCard,
    TopMenosVendidosCard,
    TopMenorFaturamentoCard,
    TopMaisCuponsCard,
    TopMenosCuponsCard,
    TopMaisClientesCard,
    TopMenosClientesCard,
  },
  data: () => ({
    loading: true,
    dataType: 'vendas',
    rankType: 'mais',
    selectedItems: [],
    activeTab: 0,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    toggleButtons() {
      return [
        {
          id: 0,
          label: 'Vendas',
          value: 'vendas',
          active: true,
        },
        {
          id: 1,
          label: 'Faturamento',
          value: 'faturamento',
          active: true,
        },
        {
          id: 2,
          label: 'Cupons',
          value: 'cupons',
          active: true,
        },
        {
          id: 3,
          label: 'Clientes',
          value: 'clientes',
          active: true,
        },
      ]
    },
    loader() {
      let loader = ['last-update', 'primeiro-registro', 'get-last-update']
      const loadersByType = {
        mais: {
          vendas: 'produtos-mais-vendidos-top',
          faturamento: 'produtos-mais-faturados-top',
          cupons: 'produtos-mais-cupons-top',
        },
        menos: {
          vendas: 'produtos-menos-vendidos-top',
          faturamento: 'produtos-menos-faturados-top',
          cupons: 'produtos-menos-cupons-top',
        },
      }
      loader.push(loadersByType[this.rankType][this.dataType])
      return loader
    },
  },
  methods: {
    getDataToExport() {
      let headers = ['Posição', 'SKU', 'Produto', 'Cupons', 'Faturamento', 'Clientes', 'Quantidade', '%']
      const rows = this.selectedItems.map((product) => [
        product.index,
        product.COD_ID_PRODUTO,
        product.DES_PRODUTO,
        product.NUM_CUPONS_TOTAL,
        product.VAL_FATURAMENTO_TOTAL,
        product.NUM_CLIENTES_TOTAL,
        product.VAL_QUANTIDADE_KG_TOTAL,
        product.PORCENTAGEM,
      ])
      return { headers, rows }
    },
    updateItems(items) {
      this.selectedItems = items
    },
  },
}
</script>
<style lang="scss">
.ranking-produtos {
  .products-card {
    height: 70vh !important;
    overflow: hidden;
  }
  .table-box {
    height: 85%;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .filter-buttons {
    position: relative;
    top: 42px;
  }
}
</style>
